"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var confirmationMainContentStyles = styles_1.makeStyles(function (theme) {
    var _a;
    return ({
        confirmationWrapper: (_a = {
                display: 'flex',
                margin: function (props) { return theme.spacing(4) + " 0 " + theme.spacing(props.marginSize) + " 0"; }
            },
            _a[theme.breakpoints.down('sm')] = {
                display: 'block',
            },
            _a),
        mainContent: {
            flexGrow: 1,
            paddingLeft: '0',
        },
        summaryWrapper: {
            display: 'flex',
            '& #mySummary': {
                flexGrow: 1,
            },
        },
    });
}, { name: 'Checkout_ConfirmationMainContent' });
exports.default = confirmationMainContentStyles;
